import React from "react";
import styled from "styled-components";

const Button = styled.button`
  color: ${({ positive }) => (positive ? "#fff" : "#000")};
  border-radius: 50%;
  background-color: ${({ positive }) => (positive ? "#009045" : "#b22222")};
  font-weight: 800;
  outline: none;
`;

export const CircleButton = ({ handleClick, positive, children }) => {
  return (
    <Button onClick={handleClick} positive={positive}>
      {children}
    </Button>
  );
};
